import { __ } from '@wordpress/i18n';

const resolvePath = (object, path, defaultValue = {}) => path
  .split('.')
  .reduce(
    (obj, part) => (
      obj && 'undefined' !== typeof obj[part] ? obj[part] : defaultValue
    ),
    object,
  );

const defaults = {
  options: {
    primary_providers: [
      'AlticeOne',
      'Cablevision',
      'frontier_auth-gateway_net',
      'Mediacom',
      'WOW',
      'DTV',
      'ATTOTT',
    ],
    enable_bypass: true,
    allow_free_preview: false,
    preview_duration: 10,
    preview_reset: 1,
    preview_reset_unit: 'days',
    lock_screen_image: null,
    bypass_screen_image: null,
    bypass_screen_logo: null,
    no_tv_provider: null,
  },
  providers_without_logo: [
    'auth_atlanticbb_net',
    'alticeone',
    'cablevision',
    'comcast_sso',
    'frontier_auth-gateway_net',
    'mediacom',
    'suddenlink',
    'wow',
    'cox',
    'verizon',
    'spectrum',
    'attott',
    'dtv',
    'att',
    'dish',
    'slingtv',
  ],
  strings: {
    account: {
      login: __('Login to TV Provider', 'nexstar'),
      logout: __('Logout from TV Provider', 'nexstar'),
    },
    free_preview: {
      header: __('Live TV Free Preview', 'nexstar'),
      connect_button_mobile: __('Connect', 'nexstar'),
      description: __('Connect your TV provider to watch', 'nexstar'),
    },
    lock_screen: {
      connect: __('Please connect your TV provider to continue watching live TV.', 'nexstar'), // eslint-disable-line max-len
      connect_button: __('Connect TV Provider', 'nexstar'),
      preview_ended: __('Your preview has ended. Please connect your TV provider to continue watching live TV.', 'nexstar'), // eslint-disable-line max-len
      unauthorized: __("We're sorry, but you are not authorized to view this content.", 'nexstar'), // eslint-disable-line quotes, max-len
      info_page: {},
    },
    select: {
      close: __('Close', 'nexstar'),
      description: __('The live TV service is only available through participating TV providers. Select your provider to login.', 'nexstar'), // eslint-disable-line max-len
      header: __('Select TV Provider', 'nexstar'),
      other_header: __('All Providers', 'nexstar'),
      other_placeholder: __('Search for your provider', 'nexstar'),
      // eslint-disable-next-line quotes
      no_option: __("I don't have a TV service provider", 'nexstar'), // eslint-disable-line max-len
      // eslint-disable-next-line quotes
      none_found: __("We're sorry, your TV service provider cannot be found.", 'nexstar'), // eslint-disable-line max-len
      none_found_link_text: __('Please let us know, so we can add it.', 'nexstar'), // eslint-disable-line max-len
    },
    bypass_screen: {
      description: __('For a limited promotional time, you can now watch live streaming without logging into your cable provider. Please click Watch Now to view our live broadcast!', 'nexstar'), // eslint-disable-line max-len
      button: __('Watch Now', 'nexstar'),
    },
  },
};

export default (path) => resolvePath(
  window.adobePrimetime ?? {},
  path,
  resolvePath(defaults, path),
);
